const getPage = (state) => ({ handle }) => {
    const page = state.pages.find(page => {
        return page.slug === handle
    })
    return page
}

export default {
    getPage
}
